import React from 'react';
import './Banner.css';

export default function Banner({ onHomeClick }) {
  return (
    <div className="banner">
      <h1 onClick={onHomeClick}>urnotniche.com {'[BETA]'}</h1>
    </div>
  );
}
